import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "login_box" }
const _hoisted_2 = { class: "login_content" }
const _hoisted_3 = { class: "content_box" }
const _hoisted_4 = { class: "login_wrap_left" }
const _hoisted_5 = { class: "swiper_box" }
const _hoisted_6 = { class: "login_wrap_right" }
const _hoisted_7 = { class: "right_conteng" }
const _hoisted_8 = {
  key: 0,
  class: "wrap_form"
}
const _hoisted_9 = { class: "wrap_form_center" }
const _hoisted_10 = { class: "form_item" }
const _hoisted_11 = { class: "wrap_form_bottom" }
const _hoisted_12 = { class: "form_bottom" }
const _hoisted_13 = { class: "wrap_form_btn" }
const _hoisted_14 = { class: "wrap_form_three" }
const _hoisted_15 = { class: "form_input" }
const _hoisted_16 = { class: "wrap_form_three" }
const _hoisted_17 = { class: "form_foot" }
const _hoisted_18 = { class: "wrap_button" }
const _hoisted_19 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Rotation = _resolveComponent("Rotation")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_button = _resolveComponent("a-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_Rotation)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _cache[9] || (_cache[9] = _createElementVNode("h2", null, "账户密码重置", -1)),
            (_ctx.isShowform)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_a_input, {
                        style: {"font-size":"14px","border-radius":"4px"},
                        class: "form_item_name",
                        value: _ctx.formData.username,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.username) = $event)),
                        placeholder: "请输入手机号",
                        onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;"
                      }, null, 8, ["value"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(_component_a_input, {
                        style: {"font-size":"14px","border-radius":"4px"},
                        class: "form_item_name",
                        placeholder: "请输入验证码",
                        value: _ctx.formData.code,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.code) = $event)),
                        onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;"
                      }, null, 8, ["value"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("button", {
                        class: "wrap_form_button",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getCode()))
                      }, "获取验证码", 512), [
                        [_vShow, _ctx.isShowcode]
                      ]),
                      _withDirectives(_createElementVNode("span", { class: "wrap_form_vaild" }, " 获取验证码(" + _toDisplayString(_ctx.count) + ") ", 513), [
                        [_vShow, !_ctx.isShowcode]
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createVNode(_component_a_input_password, {
                  style: {"font-size":"14px","border-radius":"4px"},
                  class: "form_input_pass",
                  value: _ctx.formData.password,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.password) = $event)),
                  placeholder: "请设置新密码(6~30位字符内容)",
                  onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;"
                }, null, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createVNode(_component_a_input_password, {
                  style: {"font-size":"14px","border-radius":"4px"},
                  class: "form_input_pass",
                  value: _ctx.formData.passwords,
                  "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.passwords) = $event)),
                  placeholder: "请设置新密码(6~30位字符内容)",
                  onkeypress: "javascript:if(event.keyCode == 32)event.returnValue = false;"
                }, null, 8, ["value"])
              ])
            ]),
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "awsc" }, null, -1)),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("p", null, [
                _cache[7] || (_cache[7] = _createTextVNode("返回", -1)),
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.open())),
                  class: "button_p"
                }, "登录")
              ]),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.modify()))
              }, {
                default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                  _createTextVNode("立即修改", -1)
                ]))]),
                _: 1
              })
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.customData
          ? _ctx.customData.copyright
          : 'Copyright © 2022 www.qing.tv All Rights Reserved Powered by Shanghai Bonwey Technology Co., Ltd'), 1)
  ]))
}